import React from "react"
import { btnCva } from "../../../ui/button"
import cn from "../../../utils/classname"

const TrialSection = () => {
  return (
    <div className="mt-20 sm:mt-[100px] lg:mt-[120px] container-lg flex flex-row justify-between items-center">
      <div className="hidden sm:flex  gap-[50px]">
        <div className="h-[420px] md:h-[360px] w-px bg-[#E7E8EC]"></div>
        <div className="h-[234px] mt-auto w-px bg-[#E7E8EC]"></div>
        <div className="h-[132px] mt-auto w-px bg-[#E7E8EC]"></div>
      </div>
      <div className="flex flex-col gap-8 mb-[100px] sm:mb-[120px]">
        <div className="sm:text-center mx-auto">
          <p className="text-jar-3 text-neutral-11 italic">
            We Develop Elite Developers
          </p>
          <div className="text-jar-8 text-neutral-12 font-semibold tracking-tight">
            Ready to get started? Access a library of books and courses on
            JavaScript, Python, AI, and more!
          </div>
        </div>
        <div className="flex flex-col gap-3 justify-center items-center">
          <a
            href="/premium/pricing/"
            className={cn(
              btnCva({ size: 4, theme: "primary", variant: "solid" }),
              "w-full sm:w-fit"
            )}
          >
            Start your free trial
          </a>
          <p className="text-1 text-neutral-11">
            7 Day Free Trial. Cancel Anytime.
          </p>
        </div>
      </div>
      <div className="hidden sm:flex flex-row-reverse  gap-[50px]">
        <div className="h-[420px] md:h-[360px] w-px bg-[#E7E8EC]"></div>
        <div className="h-[234px] mt-auto w-px bg-[#E7E8EC]"></div>
        <div className="h-[132px] mt-auto w-px bg-[#E7E8EC]"></div>
      </div>
    </div>
  )
}

export default TrialSection
